// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCv0j5DD0Ly_kyMzE8JUgYZQOzl7vQbsD8",
  authDomain: "gule-sider.firebaseapp.com",
  projectId: "gule-sider",
  storageBucket: "gule-sider.firebasestorage.app",
  messagingSenderId: "946296129135",
  appId: "1:946296129135:web:f18066ea49a51085a16f9a",
  measurementId: "G-MLK1P2JWL0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;